export const ForkIcon = ({
  height = 16,
  width = 16,
  ...props
}: {
  height?: number
  width?: number
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3476 4.81254C11.9899 4.81254 12.5106 4.2923 12.5106 3.65056C12.5106 3.00881 11.9899 2.48857 11.3476 2.48857C10.7053 2.48857 10.1846 3.00881 10.1846 3.65056C10.1846 4.2923 10.7053 4.81254 11.3476 4.81254ZM11.3476 5.80111C12.5363 5.80111 13.5 4.83828 13.5 3.65056C13.5 2.46284 12.5363 1.5 11.3476 1.5C10.1588 1.5 9.19513 2.46284 9.19513 3.65056C9.19513 4.83828 10.1588 5.80111 11.3476 5.80111Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83199 13.5114C8.4743 13.5114 8.99499 12.9912 8.99499 12.3494C8.99499 11.7077 8.4743 11.1875 7.83199 11.1875C7.18969 11.1875 6.66899 11.7077 6.66899 12.3494C6.66899 12.9912 7.18969 13.5114 7.83199 13.5114ZM7.83199 14.5C9.02075 14.5 9.98443 13.5372 9.98443 12.3494C9.98443 11.1617 9.02075 10.1989 7.83199 10.1989C6.64324 10.1989 5.67956 11.1617 5.67956 12.3494C5.67956 13.5372 6.64324 14.5 7.83199 14.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32671 7.78821V11.1789H7.33728V7.78821H8.32671Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.89303 5.55047V7.35077H3.90359L3.90359 5.55047H4.89303Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8423 5.21554V7.33532H10.8528V5.21554H11.8423Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8423 7.29393C11.8423 7.56692 11.6208 7.78821 11.3476 7.78821H4.39831C4.12509 7.78821 3.9036 7.56692 3.9036 7.29393C3.9036 7.02094 4.12509 6.79964 4.39831 6.79964H11.3476C11.6208 6.79964 11.8423 7.02094 11.8423 7.29393Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.48944 2.73928V4.5619H5.30731V2.73928H3.48944ZM2.99472 1.7507C2.72149 1.7507 2.5 1.972 2.5 2.24499V5.05618C2.5 5.32917 2.72149 5.55047 2.99472 5.55047H5.80203C6.07525 5.55047 6.29675 5.32917 6.29675 5.05618V2.24499C6.29675 1.972 6.07525 1.7507 5.80203 1.7507H2.99472Z"
        fill="currentColor"
      />
    </svg>
  )
}
